import { z } from 'zod';
import { isoDate, memberRole, phone, uuid } from './common.js';

export const otpRequest = z.object({ phone });
export const otpRequestResponse = z.object({
  /** Seconds until another code can be requested. */
  retryAfterSec: z.number(),
});

export const otpVerify = z.object({
  phone,
  code: z.string().regex(/^\d{6}$/, 'Enter the 6-digit code'),
  deviceLabel: z.string().max(80).optional(),
});

export const userDto = z.object({
  id: uuid,
  phone: z.string(),
  name: z.string().nullable(),
  email: z.string().nullable(),
  locale: z.string(),
  /** True for the platform operator: may review society sign-up requests. Set by server configuration only. */
  platformAdmin: z.boolean().default(false),
});
export type UserDto = z.infer<typeof userDto>;

export const membershipDto = z.object({
  id: uuid,
  communityId: uuid,
  communityName: z.string(),
  role: memberRole,
  title: z.string().nullable(),
  unitId: uuid.nullable(),
  unitLabel: z.string().nullable(),
  canApproveVisitors: z.boolean(),
});
export type MembershipDto = z.infer<typeof membershipDto>;

export const tokenPair = z.object({
  accessToken: z.string(),
  accessExpiresAt: isoDate,
  refreshToken: z.string(),
  user: userDto,
  memberships: z.array(membershipDto),
});
export type TokenPair = z.infer<typeof tokenPair>;

export const refreshRequest = z.object({ refreshToken: z.string().min(20).max(200) });
export const logoutRequest = refreshRequest;

export const meResponse = z.object({ user: userDto, memberships: z.array(membershipDto) });
export const updateMe = z.object({
  name: z.string().trim().min(1).max(80).optional(),
  email: z.email().max(120).nullable().optional(),
  locale: z.enum(['en', 'hi']).optional(),
});

export const consentRequest = z.object({
  purpose: z.enum(['terms', 'privacy_notice', 'visitor_photo']),
  version: z.string().min(1).max(20),
});
